export default __webpack_public_path__ + "d9fccd7d7bceda480be4171eae3208f2.png";